'use es6';

import * as RespondentTypes from 'feedback-schema/constants/respondentTypes';
import { oneOfObjectValues } from 'feedback-utils/propTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Record } from 'immutable';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import { NavMarker } from 'react-rhumb';
import { CharacterCounter } from 'foundations-components/transitional/components/CharacterCounter';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { View } from 'foundations-components/components/View';
import { Popover, PopoverHeader, PopoverCloseButton, PopoverBody } from 'foundations-components/transitional/components/Popover';
import * as Modes from '../../constants/modes';
import { EMPTY_STRING, Selectors } from '../../Constants';
import PreviewRibbon from '../PreviewRibbon';
import SubmitButton from '../SubmitButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const INPUT_CHAR_LIMIT = 1500;
class FollowUp extends Component {
  constructor(props) {
    super(props);
    this.dismissPopover = () => {
      console.warn('dismissing this popover because of reasons');
      this.setState({
        popoverOpen: false
      });
    };
    this.state = {
      followUpInputValue: EMPTY_STRING,
      popoverOpen: true
    };
  }
  handleFollowUpChange({
    target: {
      value
    }
  }) {
    this.setState({
      followUpInputValue: value
    });
  }
  isButtonDisabled() {
    const {
      submitButtonDisabled
    } = this.props;
    const {
      followUpInputValue
    } = this.state;
    return submitButtonDisabled || followUpInputValue.length > INPUT_CHAR_LIMIT;
  }
  render() {
    const {
      autoFocus,
      mode,
      onSubmitClick,
      respondentType,
      config: {
        followUpQuestions: {
          [respondentType.toLowerCase()]: question
        },
        submitLabel,
        themeColor
      }
    } = this.props;
    const {
      followUpInputValue,
      popoverOpen
    } = this.state;
    const isLivePreview = mode === Modes.LIVE_PREVIEW;
    return /*#__PURE__*/_jsxs("div", {
      className: "follow-up-page",
      children: [/*#__PURE__*/_jsx("div", {
        className: "heading",
        "data-selenium-test": Selectors.FOLLOW_UP.TEXT,
        children: question
      }), /*#__PURE__*/_jsxs(View, {
        paddingInline: "500",
        paddingBlockStart: isLivePreview ? '900' : '300',
        children: [isLivePreview && /*#__PURE__*/_jsx(PreviewRibbon, {}), /*#__PURE__*/_jsx(CharacterCounter, {
          id: "input",
          counter: "down",
          max: INPUT_CHAR_LIMIT,
          renderInput: ({
            count,
            value,
            onChange
          }) => /*#__PURE__*/_jsx(NavMarker, {
            name: "follow_up",
            children: /*#__PURE__*/_jsx(TextArea, {
              defaultFocused: autoFocus,
              "data-selenium-test": Selectors.FOLLOW_UP.INPUT,
              error: count < 0,
              onChange: (...args) => {
                onChange(...args);
                this.handleFollowUpChange(...args);
              },
              resize: false,
              rows: 5,
              value: value
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Popover, {
        content: /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsxs(PopoverHeader, {
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "testHeader"
            }), /*#__PURE__*/_jsx(PopoverCloseButton, {
              popoverUse: "longform",
              onClick: this.dismissPopover
            })]
          }), /*#__PURE__*/_jsx(PopoverBody, {
            children: /*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "testBody"
              })
            })
          })]
        }),
        open: isLivePreview && popoverOpen,
        constrainTarget: true,
        placement: "right top",
        menuInlineSize: "250px",
        use: "longform",
        children: /*#__PURE__*/_jsx(SubmitButton, {
          disabled: this.isButtonDisabled(),
          onClick: () => onSubmitClick(followUpInputValue),
          themeColor: themeColor,
          children: submitLabel
        })
      })]
    });
  }
}
FollowUp.propTypes = {
  autoFocus: PropTypes.bool.isRequired,
  config: PropTypes.instanceOf(Record).isRequired,
  mode: oneOfObjectValues(Modes),
  onSubmitClick: PropTypes.func.isRequired,
  respondentType: oneOfObjectValues(RespondentTypes).isRequired,
  submitButtonDisabled: PropTypes.bool.isRequired
};
export default FollowUp;